module.exports = __webpack_public_path__ + "img/CS-Hybrid_Ad-U_1.4e3e30ef.jpg";